import React from 'react';
import {
  OVERLAY_ACTION_JUMP,
  OVERLAY_ACTION_NAVIGATION,
  OVERLAY_ACTION_SEEK,
  OVERLAY_ACTION_URL,
  Point,
  VideoOverlay,
} from '../../../../data/models/LessonContent/ContentFreeform';
import {LessonContentOverlayVideo} from '../../../../data/models/LessonContent/LessonContentBase';
import './styles.css';
import {getSecondsFromTimeText} from '../../../../utils/getTimeTextFromSeconds';

interface Props {
  width: number;
  onPause: () => void;
  seekTo: (second: number) => void;
  jumpToNode: (nodeId: string) => void;
  navigateTo: (lessonId: string) => void;
  overlayNode: LessonContentOverlayVideo;
  progress: number;
  removeDarkening?: boolean;
}

const BASELINE_WIDTH = 500;

const FreeformOverlay = React.memo(
  ({
    width,
    onPause,
    progress,
    overlayNode,
    seekTo,
    jumpToNode,
    navigateTo,
    removeDarkening,
  }: Props) => {
    const getObjectPath = (overlay: VideoOverlay) => {
      const points = overlay.overlayCoordinates;
      let path = 'M';
      if (points.length === 0) {
        return '';
      }

      points.forEach((point: Point) => {
        path += point.x + ' ' + point.y + ' ';
      });
      path += 'z';
      return path;
    };

    const shouldShowOverlay = (overlay: VideoOverlay) => {
      if (
        overlay.overlayStartTime >= progress ||
        overlay.overlayEndTime <= progress
      ) {
        return false;
      } else {
        return true;
      }
    };

    const onOpenUrl = (url: string) => {
      onPause();
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      window.open(url, '_blank').focus();
    };

    const handleOverlayAction = (overlay: VideoOverlay) => {
      if (overlay.actionType === OVERLAY_ACTION_URL && overlay.payload) {
        onOpenUrl(overlay.payload);
      } else if (
        overlay.actionType === OVERLAY_ACTION_SEEK &&
        overlay.payload
      ) {
        seekTo(getSecondsFromTimeText(overlay.payload));
      } else if (
        overlay.actionType === OVERLAY_ACTION_JUMP &&
        overlay.payload
      ) {
        jumpToNode(overlay.payload);
      } else if (
        overlay.actionType === OVERLAY_ACTION_NAVIGATION &&
        overlay.payload
      ) {
        navigateTo(overlay.payload);
      }
    };

    const getScaleFactor = () => {
      const scale = (width * 100) / BASELINE_WIDTH;
      return scale / 100;
    };

    return (
      <div>
        <div
          style={{
            width,
            height: width / 1.77,
            backgroundColor: removeDarkening ? 'none' : 'rgba(0, 0, 0, 0.188)',
          }}
          className="FreeformOverlayCanvas">
          <svg
            width={BASELINE_WIDTH}
            height={BASELINE_WIDTH / 1.77}
            transform={`scale(${getScaleFactor()})`}>
            {overlayNode.overlays.map((overlay, index) => {
              if (shouldShowOverlay(overlay)) {
                return (
                  <path
                    fillOpacity={0.4}
                    key={index}
                    fill={overlay.overlayVisible ? '#3DA2FF' : 'transparent'}
                    d={getObjectPath(overlay)}
                    onPointerDown={() => handleOverlayAction(overlay)}
                    cursor="pointer"
                  />
                );
              }
            })}
          </svg>
        </div>
      </div>
    );
  },
);

export default FreeformOverlay;
